import { BigNumber } from 'ethers';
import React from 'react';

interface LoanLoadingContextProps {
    refresh: number;
    forceRefresh: () => void;
    serviceFee: number;
    fee30Days: number;
    loanTickInfo: LoanTickInfo;
    setLoanTickInfo: (loanTickInfo: LoanTickInfo) => void;
}

const LoanLoadingContext = React.createContext({} as LoanLoadingContextProps);

//point
interface PointContextProps {
    refresh: number;
    setRefresh: (refresh: number) => void;
    balance: string;
    setBalance: (balance: string) => void;
}
const PointContext = React.createContext({} as PointContextProps);

//mint
interface MintContextProps {
    refresh: number;
    setRefresh: (refresh: number) => void;
}

const MintContext = React.createContext({} as MintContextProps);

interface ManagementProps {
    dappInfo: DappManageVo;
    setDappInfo: (dappNo: DappManageVo) => void;
    openModel: boolean;
    setOpenModel: (openModel: boolean) => void;
    refresh: number;
    setRefresh: (refresh: number) => void;
    title: string;
    setTitle: (title: string) => void;
    modelInputType: string;
    setModelInputType: (modelInputType: string) => void;
}
const ManagementContext = React.createContext({} as ManagementProps);

interface TokenManagementProps {
    refresh: number;
    setRefresh: (refresh: number) => void;
    openModel: boolean;
    setOpenModel: (openModel: boolean) => void;
    title: string;
    setTitle: (title: string) => void;
    type: string;
    setType: (type: string) => void;
    loadedTokens: boolean;
    setLoadedTokens: (v: boolean) => void;
    tokenInfo: TokenManagementVo;
    setTokenInfo: (tokenInfo: TokenManagementVo) => void;
    mintTokenAmount: string;
    setMintTokenAmount: (mintTokenAmount: string) => void;
    price: string;
    setPrice: (price: string) => void;
    tokenTotalValue: BigNumber;
    setTokenTotalValue: (tokenTotalValue: BigNumber) => void;
    tvlValue: BigNumber;
    setTvlValue: (tvlValue: BigNumber) => void;
}
const TokenManagementContext = React.createContext({} as TokenManagementProps);

interface AiComponentProps {
    openHistory: boolean;
    setOpenHistory: (openHistory: boolean) => void;
    conversationId: string;
    setConversationId: (conversationId: string) => void;
    visible: boolean;
    setVisible: (visible: boolean) => void;
}

const AiComponentContext = React.createContext({} as AiComponentProps);

export { LoanLoadingContext, PointContext, MintContext, ManagementContext, TokenManagementContext, AiComponentContext };
